export default __webpack_public_path__ + "static/media/wow about.24f27800.png";